import {createAction} from 'typesafe-actions';

import {
  type RunFieldsFragment,
  type RunSelectorRunsQuery,
} from '../../generated/graphql';
import type * as RunTypes from '../../util/runTypes';
export {deleteRun, updateRun, updateRunTags} from '../runs-low/actions';

/** The `after` and `limit` a set of runs was fetched with */
export type RunSelectorRunsPage = {
  after?: string | null;
  limit?: number | null;
};

export type RunSelectorRunsData = {
  lastUpdatedAt: string;
  /** The page these runs belong to; missing on entries cached before runs were paged by offset */
  page?: RunSelectorRunsPage;
  runs: RunTypes.Run[];
  totalRuns: number;
  pinnedRuns: RunTypes.Run[];
};

export type LeanRunSelectorGroup = {
  id: string;
  value?: unknown;
  label: string;
  count: number;
  subgroupCount?: number | null;
  hasActiveRuns?: boolean;
};

type ProjectResult = NonNullable<NonNullable<RunSelectorRunsQuery['project']>>;
type QueryResultsData = {
  runs: {
    delta: NonNullable<ProjectResult['runs']>['delta'];
    totalCount: number;
    deltaOrder: string[];
  };
  pinnedRuns: RunFieldsFragment[] | null;
};

export const processQueryResults = createAction(
  '@runSelectorRuns/processQueryResults',
  action =>
    (
      queryId: string,
      requestedPinnedRunIds: string[],
      data: QueryResultsData,
      page?: RunSelectorRunsPage
    ) =>
      action({queryId, requestedPinnedRunIds, data, page})
);

export const processLeanGroupResults = createAction(
  '@runSelectorRuns/processLeanGroupResults',
  action =>
    (
      queryId: string,
      groupKeys: string[],
      data: {groups: LeanRunSelectorGroup[]; totalCount: number},
      page?: RunSelectorRunsPage
    ) =>
      action({queryId, groupKeys, data, page})
);

export const removeQuery = createAction(
  '@runSelectorRuns/removeQuery',
  action => (queryId: string) => action({queryId})
);

export const loadRunSelectorRunsFromCache = createAction(
  '@runSelectorRuns/loadRunSelectorRunsFromCache',
  action => (queryId: string, data: RunSelectorRunsData) =>
    action({queryId, data})
);
